import React, { useEffect, useState } from 'react';
import { formatContentfulComponentProps } from '../../../../../utils/globals';
import { IBlock } from '../../../../../utils/types/contentful';
import { Body } from '../../../Elements';
import { HeaderBannerAccountLinks } from './AccountLinks/HeaderBannerAccountLinks';
import { BannerLanguageCurrencySwitch } from './LanguageCurrencySwitch';

interface HeaderBannerProps {
  bodies: IBlock;
  languageCurrencySwitch: IBlock;
  account: IBlock;
}

export const PureHeaderBanner = ({
  bodies,
  languageCurrencySwitch,
  actions,
}: HeaderBannerProps) => {
  let timer;
  const [bodyIndex, setBodyIndex] = useState(0);

  const updateCount = () => {
    setInterval(() => {
      setBodyIndex((count) => {
        if (count === 1) {
          return 0;
        } else {
          return 1;
        }
      });
    }, 3000);
  };

  useEffect(() => {
    updateCount();
    return () => clearInterval(timer);
  }, []);

  return (
    <div className='w-full sticky h-8 text-xs sm:text-sm z-50 px-4 sm:px-6 lg:px-10 py-2 lg:py-0 flex justify-between items-center text-white bg-primary'>
      <div className='hidden lg:flex w-3/12 items-center justify-start'>
        <BannerLanguageCurrencySwitch {...languageCurrencySwitch} />
      </div>
      <div className='w-full lg:w-6/12 overflow-ellipsis flex text-center items-center justify-center'>
        {bodies?.items.map((item, index) => (
          <div
            className={`absolute ${
              bodyIndex === index ? 'opacity-100' : 'opacity-0'
            } transition duration-1000 ${
              bodyIndex !== index ? '' : 'delay-700'
            }`}>
            <Body {...item} />
          </div>
        ))}
      </div>
      <div className='hidden lg:flex w-3/12 items-center justify-end'>
        <HeaderBannerAccountLinks
          {...formatContentfulComponentProps(actions)}
        />
      </div>
    </div>
  );
};

export const HeaderBanner = (props) => (
  <PureHeaderBanner {...formatContentfulComponentProps(props)} />
);
